import Image1 from '../../assets/images/contact-us-hero.jpg';

export const ContactContent = {
    heroBreadCrumb: {
        image: Image1,
        header: 'GET IN TOUCH WITH US',
        description: 'We value your feedback and are committed to responding promptly to all inquiries'
    },
    paragraph1: {
        header: "Contact us",
        description: "RAYKOS welcomes business inquiries, feedback, and suggestions from clients and partners. Reach out to us through any of the channels below, and our team will be delighted to assist you."
    },
    contactForm: {
        title: 'Get In Touch',
        firstNameLabel: 'First Name',
        lastNameLabel: 'Last Name',
        emailLabel: 'Email',
        subjectLabel: 'Subject',
        messageLabel: 'Message',
        buttonLabel: 'Send Message'
    },
    sectionBanner: {
        header: "Explore Our Product Range",
        description:
          "Interested in our pharmaceutical solutions? Browse our complete product catalog featuring innovative formulations across multiple therapeutic categories.",
        button: {
          url: "/products",
          name: "View Products",
        },
    }
}